<template>
<el-input v-model="value" placeholder="文献信息" type="textarea" />
<el-button type="primary" @click="handlePaste" class="mt-[10px]">
  粘贴识别
</el-button>
<div 
    class="flex justify-between border w-[100%] h-[65px] mb-[20px] p-[10px] rounded-sm" 
    :class="{
        'bg-[#e3eefb]': modelValue.includes(literatureValue),
        'border-[#409eff]': modelValue.includes(literatureValue)
    }"
    v-if="literatureValue">
    <div><span>{{literatureValue}}</span></div>
    <el-checkbox label="选择" size="large" @change="(e) => handleCheck(e)" />
</div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { toRefs, defineEmits } from 'vue';
import { defineProps } from 'vue';
const emit = defineEmits(['update:modelValue'])
interface Props {
modelValue: any[];
}
const props = defineProps<Props>();
const { modelValue } = toRefs(props);
const value = ref('')
const literatureValue = ref('')
const handlePaste = () => {
    console.log(value.value)
    literatureValue.value = value.value
}
const handleCheck = (e: any) => {
    console.log(e)
    if (e) {
        modelValue.value.push(literatureValue.value)
    } else {
        modelValue.value.splice(modelValue.value.indexOf(literatureValue.value), 1)
    }
    emit('update:modelValue', modelValue.value)
}
</script>